import Navbar from "./Navbar";
import "./Cyberkongz.scss";
import ckVx from "../assets/ck-vx.png";
import gm5 from "../assets/ck-5.png";
import gm20 from "../assets/ck-20.png";
import { GMsV4 } from "../typechain-types/contracts/GMsV4.sol/GMsV4";
import useProvider from "../hooks/useProvider";
import { BigNumber, ethers } from "ethers";
import { useEffect, useState } from "react";
import CONTRACT_INFO, { BANANA_ADDRESS, BANANA_ABI } from "../ContractInfo";

const Cyberkongz = () => {
  const [bananaToBurn, setBananaToBurn] = useState(50);
  const [gmPoints, setGmPoints] = useState(5);
  const [userBananas, setUserBanans] = useState<String>();
  const provider = useProvider(137);

  const bananaContractConnected = provider
    ? new ethers.Contract(BANANA_ADDRESS, BANANA_ABI, provider.getSigner())
    : undefined;

  const gmsContractConnected = provider
    ? (new ethers.Contract(
        CONTRACT_INFO[window.chain].contract,
        CONTRACT_INFO[window.chain].abi,
        provider.getSigner()
      ) as GMsV4)
    : undefined;

  useEffect(() => {
    const fetchBalance = async () => {
      if (bananaContractConnected) {
        const bananaBalanceInWei = await bananaContractConnected.balanceOf(
          provider?.getSigner().getAddress()
        );
        const bananaBalance = Number(
          ethers.utils.formatEther(bananaBalanceInWei)
        );
        const bananaBalanceNumber = bananaBalance.toFixed(3);
        setUserBanans(bananaBalanceNumber);
      }
    };

    fetchBalance();
  }, [provider]); // eslint-disable-line react-hooks/exhaustive-deps

  const checkAllowance = async (): Promise<ethers.BigNumber> => {
    console.log("checck allowance called");
    if (bananaContractConnected && provider) {
      const allowance = await bananaContractConnected.allowance(
        provider.getSigner().getAddress(),
        CONTRACT_INFO[window.chain].contract
      );
      return allowance;
    }
    return BigNumber.from(0);
  };

  const approveBananas = async () => {
    // const approveTx = await bananaContractConnected?.approve(CONTRACT_INFO[window.chain].contract, ethers.constants.MaxUint256)
    // console.log(approveTx)
    const allowance = await checkAllowance();
    const bananaToBurnBigNumber = ethers.utils.parseUnits(
      bananaToBurn.toString(),
      "ether"
    );
    if (allowance.lt(bananaToBurnBigNumber)) {
      bananaContractConnected?.approve(
        CONTRACT_INFO[window.chain].contract,
        bananaToBurn
      );
    }
    console.log(allowance.toString());
    console.log(bananaToBurnBigNumber.toString());
    const burnTx = await gmsContractConnected?.burnBananasForGMs(
      bananaToBurnBigNumber
    );
    // const burnTx = await gmsContractConnected?.burnBananasForGMs(ethers.utils.parseEther("50"))
    console.log(burnTx);
  };

  const incrementBanana = () => {
    const newBananaCount = bananaToBurn + 50;
    setBananaToBurn(newBananaCount);

    const numberOf20GmPoints = Math.floor(newBananaCount / 100);
    const numberOf5GmPoints = newBananaCount % 100;

    const totalUpdatedPoints = numberOf20GmPoints * 20 + numberOf5GmPoints / 10;

    setGmPoints(totalUpdatedPoints);
  };

  const decrementBanana = () => {
    if (bananaToBurn > 0) {
      const newBananaCount = bananaToBurn - 50;
      setBananaToBurn(newBananaCount);

      const numberOf20GmPoints = Math.floor(newBananaCount / 100);
      const numberOf5GmPoints = newBananaCount % 100;

      const totalUpdatedPoints =
        numberOf20GmPoints * 20 + numberOf5GmPoints / 10;

      setGmPoints(totalUpdatedPoints);
    }
  };

  return (
    <>
      <div className="ck-page-container">
        <Navbar />
        <div className="ck-burn-container">
          <figure className="ck-vx-container">
            <img className="ck-vx-image" src={ckVx} alt="ck" />
          </figure>
          <div className="ck-card-container">
            <div className="ck-card">
              <div className="ck-card-title">
                Burn <span>$BANANA</span>
              </div>
              <div className="ck-card-subtitle">
                Earn exclusive GM points reserved
                <br /> for $BANANA burners.
              </div>
              <div className="ck-gm-container">
                <figure>
                  <img className="ck-gm-image" src={gm5} alt="gm-5" />
                  <figcaption>
                    50 $BANANA
                    <br />5 GM points
                  </figcaption>
                </figure>
                <figure>
                  <img className="ck-gm-image" src={gm20} alt="gm-20" />
                  <figcaption>
                    100 $BANANA
                    <br />
                    20 GM points
                  </figcaption>
                </figure>
              </div>
              <div className="ck-gm-selector-container">
                <div className="ck-banana-container">
                  <div className="ck-gm-selector-title">$BANANA:</div>
                  <div className="ck-banana-counter">
                    <div
                      onClick={decrementBanana}
                      className="ck-counter ck-minus-button"
                    >
                      &nbsp;&nbsp;-&nbsp;&nbsp;
                    </div>
                    <div className="ck-banana-display">{bananaToBurn}</div>
                    <div
                      onClick={incrementBanana}
                      className="ck-counter ck-plus-button"
                    >
                      &nbsp;&nbsp;+&nbsp;&nbsp;
                    </div>
                  </div>
                </div>

                <div className="ck-points-container">
                  <div className="ck-gm-selector-title">GM points:</div>
                  <div className="ck-gm-points">{gmPoints}</div>
                </div>
              </div>
              <div className="ck-mint-button-container">
                <button
                  className="ck-mint-button"
                  disabled={gmPoints < 5}
                  onClick={approveBananas}
                >
                  {gmPoints < 5
                    ? "MINT 0 GM POINTS"
                    : `MINT ${gmPoints} GM POINTS`}
                </button>
              </div>
              <div className="ck-user-banana-balance-container">
                <div className="ck-user-banana-balance">
                  $BANANA balance: {userBananas}
                </div>
                <div className="ck-explainer-text">
                  We recommend setting approval to default value for
                  $BANANA.&nbsp;
                  <span className="ck-explainer-text-link">Here's why</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Cyberkongz;
